






























import { FormElement } from '@/models/Form';
import { Prop, Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import ElementBase from './ElementBase.vue';

@Component({
    name: 'ElementInputOptions',
    components: {
        'element-base': ElementBase,
    },
    computed: mapGetters(['errors']),
})
export default class ElementInputOptions extends Vue {
    errors!: string[];
    isMultiple: boolean = false;
    value!: string[] | string;

    @Prop() element!: FormElement;

    created() {
        this.isMultiple = this.element.params.isMultiple;
        this.value = this.isMultiple ? [] : '';
    }

    validate() {
        this.$store.commit('clearErrors');

        if (this.isMultiple && !this.value.length) {
            this.$store.commit('addError', 'Make sure to pick at least one answer.');
        }

        if (!this.isMultiple && this.value === '') {
            this.$store.commit('addError', 'Make sure to pick one answer.');
        }
    }

    submit() {
        this.validate();
        if (!this.errors.length) {
            this.$emit('submit', this.value);
        }
    }
}
